type PredicateFunction<T> = (value: T) => boolean;

/* eslint-disable @typescript-eslint/no-explicit-any */
const findKey = <T>(obj: Record<string, any>, predicate: PredicateFunction<T>): string | undefined => {
  for (const key in obj) {
    if (obj.hasOwnProperty(key) && predicate(obj[key])) {
      return key;
    }
  }
  return undefined;
};

export { findKey };
